<template>
    <section>
        <div class="big_box">
            <p></p>
            <div class="rotate_box">
                <div class="img_box" :class="{stopAnimation: activeVal}">
                    <div></div>
                </div>
            </div>
            <div class="rotate_icon_box" :class="{stopAnimation: activeVal}">
                <div class="icon icon1" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon2" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon3" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon4" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon5" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon6" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon7" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon8" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon9" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon10" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon11" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
                <div class="icon icon12" :class="{stopAnimation: activeVal}" @mouseenter="stopRotate" @mouseout="startRotate"></div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                activeVal: false
            }
        },
        methods: {
            stopRotate(){
                this.activeVal = true;
            },
            startRotate(){
                this.activeVal = false;
            }
        },
    }
</script>
<style scoped>
    .big_box{
        height: 700px;
        width: 700px;
        margin: 0 auto;
        position: relative;
    }
    .big_box p{
        position: absolute;
        top: -30px;
        left: 330px;
        width: 0px;
        height: 0px;
        border-top: 20px solid #666;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 20px solid transparent;
    }
    .rotate_box{
        height: 100%;
    }
    .img_box{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 400px;
        height: 400px;
        border-radius: 50%;
        animation: move1 30s ease infinite normal;
    }
    .img_box div{
        width: 200px;
        height: 400px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 200px 0 0 200px;
    }
    .rotate_icon_box{
        position: absolute;
        top: 0;
        width: 700px;
        height: 700px;
        animation: move2 30s ease infinite normal;
    }
    .icon{
        position: absolute;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        animation: move3 30s ease infinite normal;
    }
    .stopAnimation{
        animation-play-state: paused;
        -webkit-animation-play-state:paused;
    }
    .icon1{
        background-image: url('../assets/productIntro/adr.png');
        top: 300px;
        left: 0;
    }
    .icon2{
        background-image: url('../assets/productIntro/yx.png');
        top: 160px;
        left: 33px;
    }
    .icon3{
        background-image: url('../assets/productIntro/xcx.png');
        top: 50px;
        left: 140px;
    }
    .icon4{
        background-image: url('../assets/productIntro/ptgl.png');
        top: 0px;
        left: 300px;
    }
    .icon5{
        background-image: url('../assets/productIntro/iphon.png');
        top: 50px;
        left: 460px;
    }
    .icon6{
        background-image: url('../assets/productIntro/gzh.png');
        top: 160px;
        left: 557px;
    }
    .icon7{
        background-image: url('../assets/productIntro/yun.png');
        top: 300px;
        left: 600px;
    }
    .icon8{
        background-image: url('../assets/productIntro/jt.png');
        top: 440px;
        left: 557px;
    }
    .icon9{
        background-image: url('../assets/productIntro/yxgl.png');
        top: 550px;
        left: 460px;
    }
    .icon10{
        background-image: url('../assets/productIntro/pos.png');
        top: 600px;
        left: 300px;
    }
    .icon11{
        background-image: url('../assets/productIntro/sy.png');
        top: 550px;
        left: 140px;
    }
    .icon12{
        background-image: url('../assets/productIntro/yd.png');
        top: 440px;
        left: 33px;
    }
    @keyframes move1{
        0%{
            background-image: url('../assets/productIntro/5_03.png');
        }
        8.3%{
            background-image: url('../assets/productIntro/4_03.png');
        }
        16.7%{
            background-image: url('../assets/productIntro/3_03.png');
        }
        25%{
            background-image: url('../assets/productIntro/1_03.png');
        }
        33.3%{
            background-image: url('../assets/productIntro/6_03.png');
        }
        41.7%{
            background-image: url('../assets/productIntro/7_03.png');
        }
        50%{
            background-image: url('../assets/productIntro/8_03.png');
        }
        58.3%{
            background-image: url('../assets/productIntro/9_03.png');
        }
        66.7%{
            background-image: url('../assets/productIntro/10_03.png');
        }
        75%{
            background-image: url('../assets/productIntro/11_03.png');
        }
        83.3%{
            background-image: url('../assets/productIntro/12_03.png');
        }
        91.7%{
            background-image: url('../assets/productIntro/2_03.png');
        }
        100%{
            background-image: url('../assets/productIntro/5_03.png');
        }
    }
    @keyframes move2{
        0%{
            transform: rotate(0deg);
        }
        8.3%{
            transform: rotate(30deg);
        }
        16.7%{
            transform: rotate(60deg);
        }
        25%{
            transform: rotate(90deg);
        }
        33.3%{
            transform: rotate(120deg);
        }
        41.7%{
            transform: rotate(150deg);
        }
        50%{
            transform: rotate(180deg);
        }
        58.3%{
            transform: rotate(210deg);
        }
        66.7%{
            transform: rotate(240deg);
        }
        75%{
            transform: rotate(270deg);
        }
        83.3%{
            transform: rotate(300deg);
        }
        91.7%{
            transform: rotate(330deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    @keyframes move3{
        0%{
            transform: rotate(-0deg);
        }
        8.3%{
            transform: rotate(-30deg);
        }
        16.7%{
            transform: rotate(-60deg);
        }
        25%{
            transform: rotate(-90deg);
        }
        33.3%{
            transform: rotate(-120deg);
        }
        41.7%{
            transform: rotate(-150deg);
        }
        50%{
            transform: rotate(-180deg);
        }
        58.3%{
            transform: rotate(-210deg);
        }
        66.7%{
            transform: rotate(-240deg);
        }
        75%{
            transform: rotate(-270deg);
        }
        83.3%{
            transform: rotate(-300deg);
        }
        91.7%{
            transform: rotate(-330deg);
        }
        100%{
            transform: rotate(-360deg);
        }
    }
</style>

